import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
    getChatConversationsApi,
    getChatMessagesApi,
} from "./chatConversationApi";

export const getChatConversations = createAsyncThunk(
    "chatConversation/getChatConversations",
    async ({ page, limit }, thunkAPI) => {
        try {
            const res = await getChatConversationsApi({ page, limit });
            return res.data.data;
        } catch (err) {
            return thunkAPI.rejectWithValue(
                err.response?.data?.message || "Failed to fetch conversations"
            );
        }
    }
);

export const getChatMessages = createAsyncThunk(
    "chatConversation/getChatMessages",
    async ({ conversationId, page, limit }, thunkAPI) => {
        try {
            const res = await getChatMessagesApi(conversationId, { page, limit });

            return {
                conversationId,
                data: res.data.data,
            };
        } catch (err) {
            return thunkAPI.rejectWithValue(
                err.response?.data?.message || "Failed to fetch messages"
            );
        }
    }
);

const chatConversationSlice = createSlice({
    name: "chatConversation",
    initialState: {
        conversations: [],
        messages: [],
        selectedConversationId: null,
        total: 0,
        loading: false,
    },
    reducers: {
        setSelectedConversation: (state, action) => {
            state.selectedConversationId = action.payload;
            state.messages = [];
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getChatConversations.pending, (state) => {
                state.loading = true;
            })
            .addCase(getChatConversations.fulfilled, (state, action) => {
                state.loading = false;
                state.conversations = action.payload?.items || [];
                state.total = action.payload?.total || 0;
            })
            .addCase(getChatConversations.rejected, (state) => {
                state.loading = false;
            })

            .addCase(getChatMessages.pending, (state) => {
                state.loading = true;
            })
            .addCase(getChatMessages.fulfilled, (state, action) => {
                state.loading = false;

                const msgs = action.payload?.data?.items || [];

                state.messages = [...msgs].reverse();
            })
            .addCase(getChatMessages.rejected, (state) => {
                state.loading = false;
            });
    },
});

export const { setSelectedConversation } = chatConversationSlice.actions;

export default chatConversationSlice.reducer;